const tr = {
    "sc_title": "Güvenlik Merkezi",
    "sc_subtitle": "GaiaShield Entegre Güvenlik Katmanı",
    "sc_tab_status": "🛡️ Koruma Durumu",
    "sc_tab_events": "📋 Güvenlik Günlüğü",
    "sc_tab_node": "⚙️ Düğüm Güvenliği",
    "sc_loading": "Güvenlik verileri yükleniyor...",
    "sc_status_secured": "Sistem Durumu: Hesap korunuyor",
    "sc_status_warning": "Sistem Durumu: Uyarılar aktif",
    "sc_desc_secured": "Aktif kritik güvenlik uyarısı yok. GaiaShield hesabınızı aktif olarak izliyor.",
    "sc_desc_warning": "Dikkat: Dikkatinizi gerektiren aktif güvenlik olayları var.",
    "sc_account_protection": "Hesap Koruması",
    "sc_message_protection": "Mesaj Koruması",
    "sc_audits": "Güvenlik Denetimleri",
    "sc_active": "AKTİF",
    "sc_failed_logins": "Başarısız Girişler",
    "sc_tamper_checks": "Müdahale Kontrolleri",
    "sc_blocked_replays": "Engellenen Yeniden Oynatmalar",
    "sc_last_check": "Son Kontrol",
    "sc_just_now": "Az Önce",
    "sc_open_warnings": "Açık Uyarılar",
    "sc_btn_acknowledge": "Onayla",
    "sc_filter_severity": "Önem Derecesi",
    "sc_filter_category": "Kategori",
    "sc_filter_hide_ack": "Onaylananları Gizle",
    "sc_btn_export": "Dışa Aktar",
    "sc_col_details": "Detaylar",
    "sc_col_time": "Zaman",
    "sc_col_status": "Durum",
    "sc_col_action": "Eylem",
    "sc_no_events": "Güvenlik olayı bulunamadı.",
    "sc_node_title": "Düğüm Operatörü Güvenlik Konsolu",
    "sc_system_health": "Sistem Sağlığı",
    "sc_last_audit": "Son Denetim",
    "sc_packed_logs": "Paketlenmiş Günlükler",
    "sc_unconfirmed_events": "Onaylanmamış Olaylar",
    "sc_operator_action": "Operatör Eylemi Gerekli",
    "sc_all_ok": "Her Şey Yolunda",
    "sc_critical_events": "Kritik Sistem Olayları",
    "ac_title": "Yönetişim ve Şikayet Merkezi",
    "ac_subtitle": "GaiaCom Yönetişim ve Kötüye Kullanım Mutabakatı",
    "ac_tab_my_reports": "Şikayetlerim",
    "ac_tab_queue": "İnceleme Sırası",
    "ac_tab_operator": "Düğüm Operatörü",
    "ac_tab_transparency": "Federasyon ve Şeffaflık",
    "ac_loading": "Veriler yükleniyor...",
    "ac_reported_cases": "Bildirilen Vakalar",
    "ac_no_reports": "Henüz herhangi bir şikayet göndermediniz.",
    "ac_case_details": "Vaka Detayları",
    "ac_appeal_submit": "İtiraz Et",
    "ac_appeal_status": "İtiraz Durumu",
    "ac_appeal_reason": "İtiraz Nedeni",
    "ac_appeal_statement": "Açıklama",
    "ac_btn_appeal": "İtirazı Gönder",
    "ac_trusted_reviewer_queue": "Güvenilir Hakem Sırası",
    "ac_case_review": "Vakayı İncele",
    "ac_review_category": "Önerilen Kategori",
    "ac_review_severity": "Önerilen Önem Derecesi",
    "ac_review_action": "Önerilen Eylem",
    "ac_review_reason": "İncelemecinin Nedeni",
    "ac_btn_submit_review": "İncelemeyi Gönder",
    "ac_node_operator_dashboard": "Düğüm Operatörü Kontrol Paneli",
    "ac_apply_action": "Eylemi Uygula (Geçersiz Kıl)",
    "ac_target_type": "Hedef Türü",
    "ac_target_id": "Hedef Kimliği (GaiaID veya Kanal Kimliği)",
    "ac_suspend": "Askıya Alma Aktif",
    "ac_reason": "Resmi Gerekçe",
    "ac_btn_apply": "Eylemi Uygula",
    "ac_transparency_title": "Mutabakat ve Şeffaflık Günlüğü",
    "ac_transparency_desc": "Tüm denetlenen kanalların ve kimliklerin herkese açık anlık görüntü kanıtları.",
    "ac_btn_snapshot": "Şeffaflık Anlık Görüntüsü Oluştur",
    "search_placeholder": "E-postaları konuya, gönderene, metne göre ara...",
    "abuse_center_title": "Kötüye Kullanım Merkezi",
    "abbrechen": "İptal etmek",
    "active_identities": "Aktif kimlikler",
    "active_identity": "Aktif kimlik",
    "add_btn": "Eklemek",
    "add_contact_title": "Kişi ekle",
    "admin": "Yönetici",
    "adressbuch": "dizin",
    "aktiviert": "Etkinleştirilmiş",
    "an": "İle",
    "anonymous_sender": "Anonim gönderen",
    "antworten": "Cevap",
    "attachment_gaia_hint": "GaiaCOM ekleri uçtan uca şifrelenmiş halde kalır.",
    "attachment_smtp_hint": "Eski SMTP, yürütülebilir/komut dosyası benzeri ekleri engeller ve e-postaları güvensiz olarak kaydeder.",
    "attachments": "Ekler",
    "auffaellig": "Dikkat çekici",
    "auth_beta_notice": "Beta test aşaması: GaiaCOM aktif olarak test ediliyor. Hatalar meydana gelebilir; Önemli tohumları güvence altına alın ve gizli iş akışlarını dikkatle inceleyin.",
    "auth_btn_login": "Kimliği yükle ve giriş yap",
    "auth_btn_register": "Kaydolun ve kripto oluşturun",
    "auth_copied": "Kopyalandı",
    "auth_copy_seed": "Tohumu kopyala",
    "auth_generate_seed": "Tohum üret",
    "auth_headline": "GaiaCOM, insanlık için oluşturulmuş ilk kuantum güvenli e-posta protokolü ve iletişim sistemidir.",
    "auth_kicker": "Kuantum Sonrası Güvenli İletişim",
    "auth_mnemonic": "Anımsatıcı ifade",
    "auth_mnemonic_placeholder": "Boşluklarla ayrılmış 12 kelime...",
    "auth_password": "şifre",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Özel anahtarlar cihazınızdan ayrılmaz. Yalnızca amaçlanan alıcılar içeriğin şifresini çözebilir.",
    "auth_proof_gaiadata_desc": "Sıfır Bilgi: Verilerinizin kontrolü sizde kalır. Meta veriler küçültülür ve düz metin profili olarak kullanılmaz.",
    "auth_proof_gaiadrop_desc": "Harici kişiler, bir hesap olmadan GaiaID'nize gizli metin mesajları gönderebilir.",
    "auth_proof_gaiaproof_desc": "Teslimat ve bütünlük kanıtları şifreli metin, gönderen ve zaman damgasının tahrif edilmediğini göstermektedir.",
    "auth_proof_gaiavault_desc": "Özel notlar, kurtarma notları ve güvenlik kayıtları yerel olarak şifrelenmiş halde kalır.",
    "auth_proof_hybrid_desc": "Kuantum Kalkanı: ML-KEM ve X25519 ile hibrit şifreleme, günümüzün saldırılarına ve şimdi sakla-daha sonra şifresini çöz risklerine karşı koruma sağlar.",
    "auth_secure_mail": "Güvenli Kuantum Birleşik Posta",
    "auth_subline": "GaiaCOM, e-posta, sohbet, kriz odaları, GaiaDrop ve yerel güvenlik dosyaları için kuantum güvenli bir iletişim sistemidir. Özel anahtarlar cihazınızda kalır, içerik uçtan uca şifrelenir ve kanıtlar düz metin olmadan dışa aktarılabilir.",
    "auth_success_btn": "Şimdi oturum açın",
    "auth_success_text": "GaiaCOM hesabınız oluşturuldu. Anahtarlar yerel olarak tohumunuzdan türetildi ve sunucuda saklanmadı.",
    "auth_success_title": "Kayıt başarılı",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Giriş/Hesap",
    "auth_toggle_login": "Hesap zaten mevcut",
    "auth_toggle_register": "Yeni hesap oluştur",
    "auth_usecase_text": "Avukatlar, şirketler, yetkililer, gazeteciler, ihbarcılar ve özel güvenlik davaları için uygundur.",
    "auth_usecase_title": "Hassas iletişim için tasarlandı",
    "auth_username": "kullanıcı adı",
    "auth_username_placeholder": "Ad girin...",
    "auth_value_chat": "E2E Sohbeti",
    "auth_value_drop": "Güvenli Bırakma",
    "auth_value_mail": "Güvenli posta",
    "auth_value_rooms": "GaiaOdaları",
    "bestaetigen": "Onaylamak",
    "bestaetigt": "Onaylandı",
    "bio_status": "Biyografi/Durum",
    "biography": "biyografi",
    "change_password_desc": "Sunucu tarafı oturum açma parolanızı değiştirir. Yerel kurtarma ifadeniz, kasa/kilit açma parolanız tarafından ayrı olarak korunmaya devam eder.",
    "change_password_menu_desc": "GaiaCOM oturum açma parolasını güncelleyin.",
    "change_password_title": "Şifre değiştir",
    "channel_id": "Kanal kimliği",
    "channel_name_label": "Kanal adı",
    "chat_deleted_hidden": "Sohbet silindi ve gizlendi.",
    "chat_input_placeholder": "Güvenli mesajı girin...",
    "chat_start_hint": "Konuşmayı başlatın! Tüm sohbet mesajları kuantum güvenli E2E şifrelidir.",
    "choose_avatar": "Avatar seç",
    "ciphertext_hash": "Şifreli Metin Karması",
    "clear_chat": "Sohbeti boşalt",
    "clear_for_everyone": "Herkes için boş",
    "clear_for_me": "Sadece benim için boş",
    "click_to_write_mail": "E-posta yazmak için tıklayın",
    "click_top_right": "Sağ üstteki tıklayın",
    "close": "Kapalı",
    "code_kopieren": "Kodu kopyala",
    "code_kopieren_success": "Kod kopyalandı",
    "confirm_clear_channel_desc": "Bu kanalı yerel görünümünüzden temizlemek istiyor musunuz?",
    "confirm_clear_channel_title": "Boş kanal",
    "confirm_clear_chat": "Bu sohbeti boşaltmak istiyor musunuz?",
    "confirm_clear_chat_desc": "Bu sohbeti boşaltmak istiyor musunuz?",
    "confirm_clear_chat_title": "Sohbeti boşalt",
    "confirm_clear_everyone": "Her iki ortak için de sohbeti boşaltmak istiyor musunuz? (Tamam = Herkes için, İptal = Sadece benim için)",
    "confirm_delete_everyone": "Mesajı her iki ortak için de silmek istiyor musunuz? (Tamam = Herkes için, İptal = Sadece benim için)",
    "confirm_delete_msg": "Bu mesajı silmek istiyor musunuz?",
    "confirm_delete_msg_desc": "Bu sohbet mesajını silmek istiyor musunuz?",
    "confirm_delete_msg_title": "Mesajı sil",
    "confirm_new_password": "Yeni şifreyi onayla",
    "copy": "Kopyala",
    "create_btn": "Yaratmak",
    "create_channel_title": "Kanal oluştur",
    "create_group_is_crisis": "Kriz alanı olarak işaretle",
    "create_group_title": "Yeni grup oluştur",
    "crypto_lock_desc": "GaiaCOM'un yerel kripto anahtarlarını bellekten ne zaman kaldıracağını kontrol eder.",
    "crypto_lock_menu_desc": "Yeniden yükleme ve hareketsizlik zamanlayıcılarını kontrol edin.",
    "crypto_lock_title": "Kriptografik kilit",
    "crypto_session_duration": "Yeniden yükledikten sonra kilidi açıldı",
    "crypto_session_duration_desc": "Kripto oturumunu bu tarayıcı sekmesinde yalnızca seçilen süre boyunca açık tutar.",
    "cryptographic_fingerprint": "Kriptografik parmak izi",
    "current_password": "Mevcut Şifre",
    "data_minimization": "Veri minimizasyonu",
    "decrypt_failed": "Deşifre edilemez",
    "delete": "Silmek",
    "delete_account_button": "Hesabı geri alınamayacak şekilde silin",
    "delete_account_confirm_label": "Onaylamak için DELETE girin",
    "delete_account_confirmation_error": "Şifre ve SİL onayı gereklidir.",
    "delete_account_desc": "Bu mod, hesabınızı, kimliklerinizi, cihaz oturumlarınızı, GaiaDrop verilerinizi, yükleme meta verilerinizi ve sunucu tarafıyla ilişkilendirilebilir mesajlarınızı kalıcı olarak yok eder.",
    "delete_account_done_desc": "Atanabilir tüm GaiaCOM verileri silindi.",
    "delete_account_done_title": "Hesap silindi",
    "delete_account_menu_desc": "Hesabı ve ilişkili verileri yok edin.",
    "delete_account_not_authenticated": "Aktif hesap yok.",
    "delete_account_title": "Hesabı sil",
    "delete_for_everyone": "Herkes için sil",
    "delete_for_me": "Sadece benim için sil",
    "device_current": "Bu cihaz",
    "device_last_seen": "Son",
    "device_logout": "Oturumu kapat",
    "device_sessions_desc": "Aktif oturumları kontrol edin ve artık güvenmediğiniz cihazların kaydını silin.",
    "device_sessions_empty": "Hiçbir cihaz bulunamadı.",
    "device_sessions_menu_desc": "Aktif oturumları yönetin ve sonlandırın.",
    "device_sessions_title": "Kayıtlı cihazlar",
    "device_since": "O zamandan beri",
    "display_name": "Ekran adı",
    "drop_address_copied": "GaiaDrop adresi kopyalandı.",
    "drop_btn_decrypting": "Gelen kutusunun şifresi çözülüyor...",
    "drop_btn_load": "GaiaDrop Gelen Kutusunu Yükle",
    "drop_delete_desc": "Bu düşüşü gerçekten kalıcı olarak silmek istiyor musunuz?",
    "drop_delete_title": "GaiaDrop'u Sil",
    "drop_desc": "Harici bildirimler, sorumlu açıklamalar ve gizli raporlar için yalnızca metin içeren sıfır bilgi bırakma kanalı. Harici taraflar, GaiaID'nizi kullanarak hesap olmadan mesaj gönderebilir.",
    "drop_empty": "Henüz GaiaDrop mesajı yüklenmedi.",
    "drop_id": "Bırakma kimliği:",
    "drop_own_address": "GaiaDrop adresiniz",
    "drop_proof": "DÜŞMEYE DAYANIKLI",
    "drop_title": "GaiaDrop Güvenli Gelen Kutusu",
    "dunkler_modus": "Karanlık mod",
    "e2e_chat_room_open": "E2E sohbet odasını aç",
    "edit_profile": "Profili düzenle",
    "edit_profile_desc": "Görünen adı, biyografiyi ve avatarı özelleştirin.",
    "einladungscode": "Davetiye kodu",
    "enter_fingerprint_chars_confirm": "Onaylamak için istenen parmak izi karakterlerini girin.",
    "envelope_hash": "Zarf karması",
    "erasability": "Silinebilirlik",
    "erfolg": "Başarı",
    "exclude_plaintext": "Düz metin olmadan dışa aktar",
    "export_disclosure": "Güvenlik vakasını dışa aktar",
    "export_package_desc": "Yalnızca bu açıklamanın kasıtlı olması durumunda düz metin ekleyin.",
    "export_package_title": "Güvenlik paketini dışa aktar",
    "fehler": "Hata",
    "gaiacom_reader": "GaiaCOM Okuyucu",
    "gaiadrop_inbox_title": "GaiaDrop Gelen Kutusu",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM meta verileri en aza indirir, özel anahtarları yerel tutar, içeriği uçtan uca şifreler ve hesabın tamamen silinmesini sağlar.",
    "gdpr_home_title": "%100 GDPR uyumlu",
    "gdpr_reason_delete": "Hesabın silinmesi hesabı, kimlikleri, yerel oturumları ve sunucu tarafı atanabilir verileri kaldırır.",
    "gdpr_reason_e2ee": "Özel içeriğin şifresi yalnızca hedeflenen alıcılar için çözülebilir durumda kalır.",
    "gdpr_reason_minimal": "Meta veriler yalnızca yönlendirme, teslimat ve güvenlik kimlik bilgileri için kullanılır.",
    "gdpr_reason_zero_knowledge": "Özel anahtarlar ve kurtarma verileri yerel olarak kullanıcı kontrolü altında kalır.",
    "gesendet": "Gönderilmiş",
    "gesperrt_verdaechtig": "Yasaklandı / Şüpheli",
    "group_delete_desc": "Bu grubu gerçekten kalıcı olarak silmek istiyor musunuz? Bu gruptaki tüm kanallar ve mesajlar silinecek.",
    "group_delete_title": "Grubu sil",
    "group_description": "Tanım",
    "group_icon_label": "Grup simgesi / avatarı",
    "group_name": "Grup adı",
    "group_settings_avatar": "avatar",
    "group_settings_desc": "Tanım",
    "group_settings_is_crisis": "Kriz alanı olarak işaretle",
    "group_settings_name": "Grup adı",
    "group_settings_title": "Grup ayarları",
    "groups_empty_desc": "Proje, kriz veya ekip iletişimi için güvenli bir çalışma alanı oluşturun.",
    "groups_empty_title": "Henüz grup sohbeti yok",
    "gruppe_beitreten": "Katılan grup",
    "gruppe_erstellen": "+ Grup oluştur",
    "gruppe_verlassen": "Gruptan ayrıl",
    "gruppen_chats": "Grup sohbetleri",
    "heller_modus": "Parlak mod",
    "how_to_receive_drops": "Dropları nasıl alabilirim?",
    "identitaets_assistent": "Kimlik Asistanı",
    "inactivity_lock_duration": "Etkin olmadığında kilitle",
    "inactivity_lock_duration_desc": "Giriş yapılmayan bu sürenin ardından GaiaCOM otomatik olarak kriptografik olarak kilitlenecektir.",
    "inactivity_lock_notice": "GaiaCOM, etkinlik olmaması nedeniyle kriptografik olarak engellendi.",
    "include_plaintext": "Düz metin ekle",
    "invite_code_label": "Davetiye kodu",
    "join_group_title": "Gruba katıl",
    "kanaele": "Kanallar",
    "kanal_erstellen": "+ kanal",
    "kein_chat_ausgewaehlt": "Seçilen sohbet yok",
    "kein_kanal_ausgewaehlt": "Hiçbir kanal seçilmedi",
    "keine_gruppe_ausgewaehlt": "Grup seçilmedi",
    "keine_mails": "E-posta yok.",
    "key_change_warn_desc": "Bu kişinin genel anahtarı değişti. Güvenmeden önce parmak izini kontrol edin.",
    "key_change_warn_title": "Şifreleme uyarısı",
    "key_change_warning_changed": "değişti. Bu, ortadaki adam saldırısının işareti olabilir!",
    "key_change_warning_msg": "Kişinin kimlik anahtarı",
    "key_transparency": "Anahtar Şeffaflığı",
    "kopiert": "Kopyalandı",
    "kryptographische_schluessel": "Şifreleme anahtarları",
    "kryptographische_schluessel_desc": "Özel anahtarları ve yedek tohum ifadesini gösterin.",
    "laden": "Yük...",
    "leeren": "Boş",
    "loading": "Yük...",
    "local_key_vault": "Yerel anahtar kasası",
    "local_keys_label": "Yerel anahtarlar",
    "lock_on_reload": "Yeniden yükledikten sonra daima kilitle",
    "logout": "Oturumu kapat",
    "mail_compose": "E-posta yaz",
    "mein_profil": "Profilim",
    "melden": "Rapor",
    "menu": "menü",
    "message": "Haberler",
    "message_id": "Mesaj Kimliği",
    "message_pin": "Sabitle",
    "message_pinned_title": "Sabitlenmiş mesajlar",
    "message_react": "Tepki ver",
    "message_reply": "Cevap",
    "message_replying_to": "Cevapla",
    "message_save": "Kaydetmek",
    "message_saved": "Kaydedildi",
    "message_to_channel": "Mesaj gönder",
    "message_unpin": "Çözmek",
    "message_unsave": "Kaydetme",
    "mitglied": "Üye",
    "mitglieder": "üyeler",
    "ml_kem": "ML-KEM",
    "neue_mail": "Yeni e-posta",
    "never_auto_lock": "Asla otomatik olarak",
    "new_fingerprint": "Yeni parmak izi",
    "new_identity": "Yeni kimlik",
    "new_password": "Yeni Şifre",
    "no_description": "Açıklama yok",
    "no_key_history": "Hiçbir anahtar geçmişi kaydedilmedi.",
    "no_specification": "Belirtilmedi",
    "old_fingerprint": "Eski parmak izi",
    "open_privacy_imprint": "Açık baskı ve veri koruması",
    "post_quantum_e2e": "Kuantum sonrası E2E",
    "posteingang": "Gelen kutusu",
    "powered_by": "Tarafından desteklenmektedir",
    "privacy_imprint_menu_desc": "GDPR'yi, veri korumayı ve yasal bildirimi gösterin.",
    "privacy_imprint_profile_desc": "GaiaCOM iletişim içeriğini veri minimizasyonu, uçtan uca şifreleme ve yerel anahtar kontrolü ilkelerine göre işler.",
    "privacy_imprint_title": "Veri koruma ve yasal bildirim",
    "profil": "profil",
    "profile_details": "Profil ayrıntıları",
    "profile_settings_hint": "Profil ayarları sağ panelde görüntülenir.",
    "profile_unlock_desc": "Güvenlik nedeniyle özel şifreleme anahtarlarınızı görüntülemek için şifrenizi yeniden girmeniz gerekir.",
    "proof_hash": "Kanıt karma:",
    "public_drop_desc": "GaiaCOM hesabı olmadan harici metin bilgileri için Güvenli Bırakma.",
    "public_drop_message": "Haberler",
    "public_drop_message_placeholder": "Gizli metni girin...",
    "public_drop_send": "GaiaDrop'u gönder",
    "public_drop_sender": "Gönderen notu isteğe bağlı",
    "public_drop_sender_placeholder": "İsim, dosya numarası veya anonim",
    "public_drop_target": "GaiaID'yi hedefle",
    "quanten_chat": "Kuantum Sohbeti",
    "quantum_secure_exchange": "Kuantum güvenli alışverişi...",
    "quantum_secure_net": "GaiaCOM Kuantum Güvenli Ağı (Ed25519 ve ML-KEM)",
    "quantum_shield_desc": "GaiaCOM ağı, geleceğin kuantum bilgisayarlarından gelebilecek saldırılara karşı korunan çok katmanlı, hibrit bir şifreleme protokolüyle gizliliğinizi korur.",
    "quantum_shield_l1_desc": "Simetrik bir paylaşılan anahtarı kapsüllemek için FIPS 203 standardını kullanır. Kuantum bilgisayarların pasif kaydetmesini ve daha sonra şifre çözmesini (\\",
    "quantum_shield_l1_title": "1. Kuantum Sonrası Koruma (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Hibrit prosedürde ek bir güvenlik katmanı görevi gören klasik, son derece hızlı bir Diffie-Hellman anahtar değişim prosedürü.",
    "quantum_shield_l2_title": "2. Eliptik Eğri Şifrelemesi (X25519)",
    "quantum_shield_l3_desc": "Gönderenin gerçekliğini kesin olarak doğrulamak için her mesaj ve her Federasyon zarfı kriptografik olarak imzalanır.",
    "quantum_shield_l3_title": "3. Dijital İmzalar (Ed25519)",
    "quantum_shield_l4_desc": "Mesaj içeriğini simetrik olarak şifreler ve tekrar gönderme saldırılarını önlemek için göndereni, alıcıyı ve meta verileri Kimliği Doğrulanmış Ek Verilere (AAD) sıkı bir şekilde bağlar.",
    "quantum_shield_l4_title": "4. AAD kimlik doğrulaması (AES-256-GCM)",
    "quantum_shield_status": "Kuantum Kalkanı durumu",
    "receive_drops_step1": "GaiaID'nizi (örneğin yukarıdaki kopyala düğmesini kullanarak) harici kaynaklarla paylaşın.",
    "receive_drops_step2": "Bunlar GaiaCOM örneğinizin oturum açma sayfasını çağırır ve sekmeye geçer",
    "receive_drops_step3": "ve şifreli mesajlarını adresinize gönderin.",
    "receiver_gaia": "GaiaCOM alıcısı",
    "receiver_smtp": "SMTP alıcısı",
    "records_stored": "Kayıtlar kaydedildi",
    "refresh": "Güncelleme",
    "report_abuse_desc": "Bu mesajı bildirmek ve kötüye kullanımın kriptografik kanıtını sunucuya göndermek istiyor musunuz?",
    "report_abuse_title": "Kötüye kullanımı bildir",
    "reputation_status": "İtibar Durumu",
    "room_chat_start_hint": "Konuşmayı başlatın! Bu grup kanalındaki tüm mesajlar merkezi olmayan kuantum açısından güvenli E2E şifrelidir.",
    "room_policy_audit": "Denetim takibi ve anahtar rotasyonu aktif.",
    "room_policy_crisis": "Kriz odası",
    "room_policy_e2ee": "Sıfır bilgi alanı. E2EE kuantum güvenli.",
    "room_policy_title": "Oda kuralları",
    "room_policy_zero_knowledge": "Politika",
    "room_security_note_desc": "Tüm önemli değişiklikler Anahtar Şeffaflığı aracılığıyla doğrulanır. Özel yedekleme günlükleri için GaiaVault'u kullanın.",
    "room_security_note_title": "Sabitlenmiş güvenlik notu",
    "save_profile": "Profili kaydet",
    "schluessel_entsperrt": "🔑 Anahtarı tekrar kilitle",
    "search_gaia_label": "Gaia adresini bulun",
    "security_warning_title": "Güvenlik uyarısı",
    "select_channel_chat": "Sohbet etmek için sol kenar çubuğundan bir kanal seçin.",
    "select_contact_chat": "Kuantum açısından güvenli bir E2E sohbeti başlatmak için sol panelden bir kişi seçin.",
    "select_mail_read": "Kuantum açısından güvenli içeriğini okumak veya yeni bir mesaj oluşturmak için listeden bir e-posta seçin.",
    "senden": "Göndermek",
    "sender_signature": "Gönderenin İmzası",
    "server_log": "Sunucu günlüğü:",
    "server_received": "Sunucu Alındı",
    "session_lock": "Oturum kilidi",
    "setup_address_keys": "Adres ve anahtar seti oluştur",
    "setup_profile": "Profilde ayarla",
    "smtp_inbox_title": "SMTP alımı",
    "smtp_legacy_badge": "Eski SMTP / Güvensiz",
    "smtp_mode_option": "Eski SMTP köprüsü",
    "smtp_security_warning": "Bu e-posta klasik, şifrelenmemiş SMTP protokolü aracılığıyla iletildi. Uçtan uca şifreleme etkin değil.",
    "smtp_security_warning_desc": "Bu mesaj GaiaCom güvenlik odasından çıkıyor. SMTP teslimatı, GaiaCom yerel uçtan uca garantisi sağlamaz, TrustMesh garantisi vermez ve ağ geçidinden Godmode garantisi vermez.",
    "spam_verdacht": "Spam/şüphe",
    "spam_warning_desc": "Bu mesaj şüpheli itibar sinyalleri içeriyor.",
    "spam_warning_title": "Spam uyarısı",
    "speichern": "Kaydetmek",
    "sperren": "Kilitle",
    "standard_group_status": "Standart grup sohbeti (E2EE şifreli)",
    "status": "durum",
    "subject": "İlişkin",
    "suchen": "Yeni bir Gaia adresi bulun...",
    "tage": "günler",
    "time_unknown": "Zaman bilinmiyor",
    "transmission_mode": "Aktarım modu",
    "trust_age": "Güven yaşı",
    "trust_passport_title": "Güven Pasaportu",
    "unbestaetigt": "Onaylanmadı",
    "unknown_sender": "Bilinmiyor",
    "unlock_btn": "Kilidi aç",
    "unlock_btn_profile": "Kilidi aç",
    "unlock_desc": "Özel anahtar dosyanız şifrelenmiş olarak saklanır. Şifreleme anahtarlarını yalnızca belleğe yüklemek için şifrenizi girin.",
    "unlock_logout": "Oturumu kapatın ve yerel anahtarları kapatın",
    "unlock_title": "Kimliğin Kilidini Aç",
    "untrusted": "Güvenilir değil",
    "update_password": "Şifreyi güncelle",
    "upload_avatar_btn": "Resim yükle (Temizlenmiş)",
    "vault_btn_encrypt": "Kaydı şifrele",
    "vault_btn_lock": "Kasayı kilitle",
    "vault_btn_unlock": "Kasanın kilidini aç",
    "vault_copied_success": "Panoya kopyalandı",
    "vault_decrypted_content": "Şifresi çözülmüş içerik",
    "vault_desc": "Kurtarma yedeklemeleri, kimlik notları, sunucu erişimi, acil durum iletişim bilgileri, yasal notlar, güvenlik olayları ve özel günlükler için yerel şifreli kasa.",
    "vault_empty": "Henüz kaydedilen güvenli kayıt yok.",
    "vault_locked_pane_notice": "Kasa kilitli. Lütfen sağdaki kilidi açın.",
    "vault_new_record": "Yeni güvenli kayıt",
    "vault_pwd_placeholder": "Kasa Şifresini Girin...",
    "vault_record_body": "İçeriği kaydet",
    "vault_record_body_placeholder": "Şifrelenmiş kayıt içeriğini girin...",
    "vault_record_category": "kategori",
    "vault_record_title": "Kayıt başlığı",
    "vault_record_title_placeholder": "Güvenli kaydın başlığı",
    "vault_title": "GaiaVault Güvenli Kayıtları",
    "verify_new_fingerprint_hint": "Anahtarı kabul etmeden önce yeni parmak izini kontrol edin.",
    "vertrauenswuerdig": "Güvenilir",
    "vision_gaia_technology": "VizyonGaiaTeknoloji",
    "von": "İtibaren",
    "warnung": "uyarı",
    "wizard_address": "adres",
    "wizard_back": "Geri",
    "wizard_check1": "Tohumumu güvenle sakladım.",
    "wizard_custom_domain": "Kendi alan adınızı kullanın",
    "wizard_desc1": "GaiaCOM özel anahtarları sunucu tarafında saklamaz. Mnemonic Seed olmadan hiç kimse kayıp mesajları kurtaramaz.",
    "wizard_desc2": "Adresiniz, şifrelenmiş zarfların yönlendirileceği birleştirilmiş düğümü belirler.",
    "wizard_fallback": "Geri dönüş düğümleri",
    "wizard_finish": "Kurulumu tamamla",
    "wizard_next": "Daha öte",
    "wizard_server_domain": "Sunucu düğüm alanı",
    "wizard_step1": "1. Yedekleme Tohumu",
    "wizard_step2": "2. Adres ve Sunucu",
    "wizard_title1": "Kurtarma anahtarını yedekle",
    "wizard_title2": "GaiaCOM adresini seçin",
    "write_message_placeholder": "Güvenli bir mesaj yazın...",
    "you": "Sen",
    "zero_knowledge": "Sıfır bilgi",
    "zero_knowledge_encryption": "Sıfır bilgi şifrelemesi",
    "Chat fuer alle geleert": "Sohbet tüm katılımcılar için boşaltıldı.",
    "Chat geleert": "Yerel gelen kutunuz için sohbet temizlendi.",
    "Nachricht fuer alle geloescht": "Mesaj tüm katılımcılar için silindi.",
    "Nachricht geloescht": "Sohbet mesajı yerel olarak gelen kutunuzdan kaldırıldı.",
    "anpinnen": "Sabitle",
    "chat_loeschen": "Sohbeti sil",
    "confirm_delete_chat_desc": "Sohbeti silmek ve gizlemek istediğinizden emin misiniz?",
    "confirm_leave_group_desc": "Gerçekten bu gruptan ayrılmak istiyor musun?",
    "entpinnen": "Sabitlemeyi kaldır",
    "group_deleted": "Grup başarıyla silindi.",
    "group_left": "Gruptan başarıyla ayrılın.",
    "gruppe_loeschen": "Grubu sil",
    "loeschen": "Silmek",
    "no_active_chats": "Aktif sohbet yok. Sohbet başlatmak için yukarıda kişileri arayın.",
    "pinned": "Sabitlendi",
    "wizard_check_credentials": "Erişim verilerimin güvende tutulmasından sorumluyum.",
    "wizard_check_is_beta": "GaiaCom'un beta yazılım olduğunu anlıyorum.",
    "wizard_check_no_illegal": "GaiaCom'u yasa dışı amaçlarla kullanmayacağım.",
    "wizard_check_no_uptime": "Kullanılabilirlik garantisinin olmadığını anlıyorum.",
    "wizard_check_smtp_security": "SMTP mesajlarının tam GaiaCom güvenliği sağlamadığını anlıyorum.",
    "wizard_check_terms_read": "Beta Hizmet Koşullarını okudum.",
    "wizard_step_terms": "Kullanım Koşulları",
    "wizard_terms_text": "GaiaCom Kullanım Koşulları ve Beta Test Sözleşmesi (Beta Aşaması)\n\nSağlayıcı: VisionGaiaTechnology (bundan sonra \"Sağlayıcı\" olarak anılacaktır)\nDurum: Herkese açık beta test aşaması\nGeçerlilik: 21 Haziran 2026'dan itibaren\n\n⚠️ŞİMDİDEN EN ÖNEMLİ NOT (LÜTFEN DİKKATLİCE OKUYUNUZ)\nGaiaCom halka açık beta test aşamasındadır. Kapsamlı güvenlik önlemlerine rağmen, yazılımın ve temel altyapının hatasız olması, sürekli kullanılabilirliği veya mutlak güvenliği garanti edilemez. Riski size ait olmak üzere kullanın. Erişim verilerinin (özellikle GaiaVault anahtarlarının) güvenli bir şekilde saklanmasından ve geçerli yasalara uygunluktan kullanıcılar sorumludur.\n\n1. Beta testi aşamasının konusu ve amacı\n1.1. Sağlanma amacı: GaiaCom, kuantum sonrası şifrelemeye (PQC) dayalı yeni bir e-posta ve sohbet hizmetidir. Beta aşamasındaki hüküm yalnızca teknik test, yük simülasyonu, program hatalarını (hataları) bulma ve kullanıcı dostu olma özelliğini optimize etme amaçlıdır.\n1.2. Beta durumu: Kullanıcı, sunulan yazılımın ön sürüm (beta yazılım) olduğunun bilincindedir. Bu henüz teknik olarak tam olarak geliştirilmemiştir, nihai ticari ürünün standardını karşılamamaktadır ve hatalara, veri kaybına, iletim gecikmelerine veya sistem çökmelerine neden olabilir.\n1.3. Devam etme hakkının olmaması: Sağlayıcı, herhangi bir zamanda herhangi bir gerekçe göstermeksizin hizmeti tamamen veya kısmen durdurma, işlevleri değiştirme veya kısıtlama veya bunları geçici veya kalıcı olarak kaldırma hakkına sahiptir.\n\n2. Garantinin Kullanılabilirliği ve Sorumluluk Reddi\n2.1. Kullanılabilirlik garantisi yok: GaiaCom, kullanılabilirlik veya çalışma süresi garantisi olmadan sağlanır. Hizmetin kesintisiz kullanılabilirliği hakkı yoktur.\n2.2. Garantinin hariç tutulması: Yazılım mevcut haliyle (“olduğu gibi”) sağlanır ve kullanılabilirliğe tabidir. Yasaların izin verdiği ölçüde, yazılımdaki maddi ve hukuki kusurlara ilişkin her türlü garanti talebi kapsam dışındadır. Özellikle yazılımın hatasız, kötü amaçlı yazılım içermediğine veya belirli bir amaca uygun olduğuna dair bir garanti yoktur.\n\n3. Risk yönetimi ve kullanıcı yükümlülükleri\n3.1. Kritik verilerin saklanmasının yasaklanması: Kullanıcı, iş açısından kritik, hayati, operasyonel açıdan gerekli veya yasal açıdan özellikle hassas verileri (hasta dosyaları, son derece hassas finansal veriler veya resmi olarak düzenlenmiş sırlar gibi) GaiaCom aracılığıyla münhasıran saklamamayı veya iletmemeyi taahhüt eder. Hizmet, öngörülemeyen arızaların kişisel yaralanma, mal hasarı veya önemli mali kayıpla sonuçlanabileceği altyapı için kullanılamaz.\n3.2. Kendinden sorumlu yedekleme: Kullanıcı, GaiaCom üzerinden aldığı veya gönderdiği, uzun vadede ihtiyaç duyduğu tüm verilerin kendi bağımsız sistemlerine (yedek kopyalar) yedeklenmesinden sorumludur. Sağlayıcı, verilerin sunucularında kalıcı olarak saklanacağını veya geri yüklenebilirliğini garanti etmez.\n\n4. Şifreleme özellikleri ve GaiaVault\n4.1. Kuantum sonrası kriptografi (PQC): GaiaCom, gelecekteki kuantum bilgisayarlardan gelecek saldırılara dayanacak şekilde tasarlanmış, son teknoloji ürünü, geleceğe yönelik şifreleme süreçlerini uygular. Ancak kullanıcı bunun dinamik ve yeni bir bilimsel alan olduğunun bilincindedir. Bilimin ve teknolojinin mevcut durumuna göre mutlak, reddedilemez güvenlik garanti edilemez. \"%100 güvenli\", \"kırılamaz\" veya \"askeri güvenli\" gibi terimler açıkça garanti edilmez.\n4.2. Kurtarma garantisi yoktur (GaiaVault): GaiaCom tutarlı bir sıfır bilgi güvenlik konseptine dayanır. Şifreleme takozları ve erişim verileri yalnızca kullanıcının kontrolünde kalır (GaiaVault aracılığıyla güvenliği sağlanır).\nÖNEMLİ: Kullanıcı parolalarını, parolalarını, özel anahtarlarını veya kurtarma tohumlarını kaybederse sağlayıcının bu verileri yeniden yapılandırma veya sıfırlama konusunda teknik yeteneği yoktur. Bu erişim verilerinin kaybı kaçınılmaz olarak kullanıcı hesabına ve burada şifrelenen tüm verilere geri dönülemez şekilde erişim kaybına yol açacaktır.\n4.3. Henüz tam olarak denetlenmemiş: Yazılım sürekli olarak dahili güvenlik kontrollerine tabi tutulmaktadır, ancak bu beta aşaması sırasında henüz bağımsız test kuruluşları tarafından nihai, kapsamlı bir harici güvenlik denetiminden geçmemiştir.\n\n5. Arayüzler, eski protokoller ve federasyon\n5.1. SMTP Köprüsü Not: GaiaCom, klasik e-posta protokolleri (SMTP gibi) aracılığıyla iletişim kurma olanağı sunar. Kullanıcı, yerel GaiaCom güvenlik alanını terk eden mesajların (örneğin geleneksel bir @gmail.com veya @gmx.de adresine gönderildiğinde) şifrelenmemiş veya üçüncü taraf sunucular aracılığıyla taşındığının bilincindedir. GaiaCom'un uçtan uca güvenlik garantileri, bu tür giden veya dışarıdan gelen eski mesajlar için yalnızca sınırlı bir ölçüde geçerlidir veya hiç geçerli değildir.\n5.2. Federasyon Notu: GaiaCom birleştirilmiş bir ağ üzerinde çalışıyorsa, mesajlar ve veriler üçüncü taraf sunucular üzerinden geçebilir. Mesajların içerikleri uçtan uca şifrelemeyle korunmaya devam ederken, meta veriler (gönderme zamanı, ilgili sunucuların IP adresleri ve alıcı adresleri gibi) bu birleştirilmiş sunucuların operatörleri tarafından teknik olarak görülebilir. Sağlayıcının, birleşik ağdaki üçüncü taraf sunucu operatörlerinin veri koruma uygulamaları üzerinde hiçbir etkisi yoktur.\n\n6. Kabul Edilebilir Kullanımlar ve Yasaklanan Faaliyetler\nKullanıcı, hizmeti uygunsuz veya yasa dışı amaçlarla kullanmamayı taahhüt eder. Özellikle aşağıdakiler yasaktır:\n- Virüs, kötü amaçlı yazılım, kimlik avı içeriği veya diğer kötü amaçlı yazılımları dağıtmak, göndermek veya barındırmak.\n- Hizmeti, hizmet reddi saldırıları (DDoS) veya istenmeyen toplu posta (spam) gerçekleştirmek için kullanmak.\n- Dolandırıcılık yapmak için sistemi kötüye kullanmak.\n- Özellikle çocukların cinsel istismarı (CSAM), terör propagandası, şiddet çağrıları veya suçla ilgili diğer içeriklerin tasvirleri olmak üzere yasa dışı içeriğin dağıtımı veya değişimi.\n\n7. Kötüye kullanım raporlama sistemi\n7.1. Kötüye kullanım içeren davranışların bildirilmesi: Kullanıcılar, kötü amaçlı iletişimleri veya yasa dışı faaliyetleri entegre kötüye kullanım sistemi aracılığıyla bildirme olanağına sahiptir.\n7.2. Raporların işlenmesi: Kötüye kullanıma karşı koruma sağlamak amacıyla, gelen raporlar teknik olarak analiz edilebilir (gizlilik ve şifreleme limitleri korunarak). Bu, bu kullanım koşullarının kanıtlanmış ihlalleri durumunda kullanıcı hesaplarının veya IP adreslerinin geçici veya kalıcı olarak askıya alınmasına yol açabilir.\n\n8. Sorumluluğun Sınırlandırılması\n8.1. Sorumluluk standardı: Beta yazılım ücretsiz olarak sağlanır. Bağış veya kredilere ilişkin yasal kurallara göre, sağlayıcı yalnızca kasıt (kasıtlı zarar) ve ağır ihmalden sorumludur.\n8.2. Veri kaybı sorumluluğunun hariç tutulması: Kaybın kasıtlı olarak veya sağlayıcının ağır ihmali nedeniyle meydana gelmediği ve kullanıcının düzenli yedeklemeler (GaiaCom dışında) yoluyla hasarı hafifletme yükümlülüğünü yerine getirmediği sürece, veri kaybı sorumluluğu hariçtir.\n8.3. Yasal sınırlar: Yukarıdaki sorumluluk sınırlamaları, yaşam, beden veya sağlığa yönelik yaralanmalar veya Ürün Sorumluluğu Yasası kapsamındaki yükümlülükler için geçerli değildir.\n\n9. Açık Kaynak\nBelirli GaiaCom bileşenleri, kitaplıkları veya istemci uygulamaları açık kaynak lisansları (örn. GPL, MIT, Apache) kapsamında lisanslanabilir. Bu bileşenlerin ilgili lisans koşulları, bu kullanım koşullarından etkilenmez ve ilgili kaynak kodu havuzlarında görüntülenebilir.\n\n10. İhracat Kontrolü ve Uyumluluk\nKullanıcı, şifreleme yazılımının sıkı ihracat kontrollerine ve yasal kısıtlamalara tabi olabileceğinin bilincindedir. Kullanıcı, GaiaCom kullanımının ikamet ettiği ülkenin yasalarını, ithalat/ihracat kısıtlamalarını veya kriptografi düzenlemelerini ihlal etmemesini sağlamaktan sorumludur.\n\n11. Veri koruma bildirimi (beta için kısa versiyon)\n11.1. Minimum veri toplama: Beta aşamasının bir parçası olarak, sağlayıcı yalnızca teknik operasyon, sorun giderme ve daha fazla geliştirme için kesinlikle gerekli olan verileri (örn. hata teşhisi için sunucu günlük dosyaları) toplar.\n11.2. İçerik hakkında bilgi yok: Tutarlı sıfır bilgi ve E2E şifrelemesi sayesinde sağlayıcı, GaiaVault'ta saklanan sohbetlerinizin, e-postalarınızın veya anahtarlarınızın içeriğine asla erişemez.\n11.3. Ayrıntılı veri koruma beyanı: Ayrıntılı veri koruma düzenlemeleri ayrı olarak bağlantılıdır ve kayıttan önce kullanıcı tarafından da dikkate alınmalıdır.\n\n12. Son hükümler\n12.1. Uygulanacak kanun: Uluslararası Mal Satışına İlişkin Sözleşmelere İlişkin BM Konvansiyonu hariç, Federal Almanya Cumhuriyeti kanunları geçerlidir.\n12.2. Değişiklik yapma hakkı saklıdır: GaiaCom aktif bir geliştirme aşamasında olduğundan, sağlayıcı bu koşulları geleceğe yönelik olarak herhangi bir zamanda uyarlama hakkını saklı tutar. Güncel sürüm uygulamada mevcuttur.",
    "wizard_terms_title": "GaiaCom Kullanım Koşulları ve Beta Test Sözleşmesi (Beta Aşaması)",
    "node_operator": "Düğüm operatörü",
    "search_channels": "Kanal ara...",
    "senior_reviewer": "Kıdemli İncelemeci",
    "trusted_reviewer": "Güvenilir İnceleyici",
    "active_frequencies": "Aktif frekanslar",
    "connected_rooms": "BAĞLANTILI ALANLAR",
    "dashboard": "Kontrol Paneli",
    "empty_chats": "Aktif sohbet yok.",
    "empty_messages": "Yeni mesaj yok.",
    "encrypted": "Şifreli",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Uygulamayı yükle",
    "install_app_desc": "Hızlı başlangıç ​​ve çevrimdışı mod için",
    "kommandozentrale_alpha": "ALPHA komuta merkezi",
    "network_online": "AĞ: ÇEVRİMİÇİ",
    "new_room": "Yeni alan",
    "no_frequencies_active": "Aktif frekans yok. İletişimi başlatmak için yeni bir oda oluşturun.",
    "no_id": "Kimlik yok",
    "open_chats": "Sohbetleri aç",
    "open_inbox": "Gelen kutusunu aç",
    "primary_identity": "BİRİNCİL KİMLİK",
    "recent_chats": "Yeni sohbetler",
    "recent_messages": "En son haberler",
    "session_encrypted": "Oturum şifrelendi: {name}",
    "session_secure": "DURUM: GÜVENLİ",
    "system_verlassen": "Çıkış sistemi",
    "write_message": "Bir mesaj yaz",
    "onboarding_step_profile": "Profil",
    "onboarding_step_security": "Koruma",
    "onboarding_step_backup": "Yedek",
    "onboarding_step_launch": "Başlat",
    "onboarding_loading_gaia_id": "Gaia-ID Yükleniyor",
    "onboarding_setup_kicker": "GaiaCom İlk Kurulum",
    "onboarding_profile_title": "GaiaCom'u kendi alanınız yapın.",
    "onboarding_profile_desc": "Görüntülenen adınız ve avatarınız yerel kontrolünüz altında kalır ve daha sonra istediğiniz zaman profilde değiştirilebilir.",
    "onboarding_security_title": "GaiaCom'un şu anda sizin için neleri koruduğu.",
    "onboarding_security_desc": "GaiaCom kimlik, anahtarlar, mesajlar ve ağ durumunu ayırır. Burada sadece kısa kullanıcı sürümünü görüyorsunuz.",
    "onboarding_backup_title": "Yedekleme gerçek acil çıkış kapınızdır.",
    "onboarding_backup_desc": "Kurtarma verileri olmadan kimse kimliğinizi kurtaramaz. Gerçek uçtan uca güvenliğin temel noktası da budur.",
    "onboarding_launch_title": "Hazır. İlk önce ne yapmak istersiniz?",
    "onboarding_launch_desc": "Hemen başlayabilir veya turu sonlandırıp kontrol panelinde çalışmaya devam edebilirsiniz.",
    "onboarding_display_name": "Görüntülenen Ad",
    "onboarding_display_name_placeholder": "GaiaCom sizi nasıl görüntülesin?",
    "onboarding_select_avatar": "Avatar Seç",
    "onboarding_sec_identity_title": "Kimlik",
    "onboarding_sec_identity_desc": "Gaia-ID'niz ağ çapanızdır. Kişiler anahtar değişikliklerini tespit edebilir.",
    "onboarding_sec_messages_title": "Mesajlar",
    "onboarding_sec_messages_desc": "İçerik yerel olarak çözülür. Düzenlenen mesajlar yeni imzalar alır.",
    "onboarding_sec_network_title": "Ağ",
    "onboarding_sec_network_desc": "Güvenlik Merkezi ve İhbar Merkezi, küresel arka kapılar olmadan riskleri görünür kılar.",
    "onboarding_sec_transparency_title": "Şeffaflık",
    "onboarding_sec_transparency_desc": "Uyarıların izlenebilir kalması için güvenlikle ilgili olayları günlüğe kaydeder.",
    "onboarding_backup_notice_title": "Normal Kullanıcılar İçin Önemli",
    "onboarding_backup_notice_desc": "Kurtarma verilerinizi bu cihazdan ayrı bir yerde saklayın. Şifre ve yedek kaybedilirse, GaiaCom bilerek kilitli kalır.",
    "onboarding_backup_consent": "Yedeğimin kurtarma ve cihaz değişikliği için kritik olduğunu biliyorum.",
    "onboarding_inbox_title": "Gelen Kutusu",
    "onboarding_inbox_desc": "E-postaları okuyun ve ilk mesajınızı yazın.",
    "onboarding_contacts_title": "Kişiler",
    "onboarding_contacts_desc": "İlk kişiyi kontrol edin veya bir sohbet başlatın.",
    "onboarding_channels_title": "Kanallar",
    "onboarding_channels_desc": "Genel frekansları keşfedin.",
    "onboarding_security_title_card": "Güvenlik Merkezi",
    "onboarding_security_desc_card": "GaiaShield durumunu görüntüleyin.",
    "onboarding_later": "Sonra",
    "onboarding_back": "Geri",
    "onboarding_continue": "Devam Et",
    "onboarding_complete_setup": "Kurulumu Tamamla",
    "auth_legal_consent": "Gizlilik politikasını ve kullanım koşullarını okudum ve kabul ediyorum.",
    "auth_show_terms": "Kullanım koşullarını göster",
    "auth_recovery_mode": "Kurtarma Modu",
    "auth_recovery_import_title": "Kurtarma Dosyası İçe Aktar",
    "auth_recovery_import_desc": "GaiaCom anahtarlarınızı şifre korumalı bir yedekleme dosyasından kurtarın. Ardından anımsatıcı ve kullanıcı adı önceden doldurulur.",
    "auth_recovery_file_pwd_placeholder": "Kurtarma dosyası şifresi",
    "auth_recovery_local_pwd_placeholder": "Yeni yerel kilit açma şifresi en az 12 karakter",
    "auth_recovery_importing": "İçe aktarılıyor...",
    "auth_recovery_decrypt": "Kurtarmayı Çöz",
    "auth_back_to_login": "Giriş Ekranına Dön",
    "auth_terms_title": "GaiaCom Beta Kullanım Koşulları",
    "auth_terms_close": "Kapat",
    "auth_cookie_title": "GaiaCOM egemen kalır.",
    "auth_cookie_desc": "Yalnızca dil, oturum ve güvenlik için teknik olarak gerekli yerel depolamayı kullanırız. Takip, reklam çerezleri veya üçüncü taraf profilleri yoktur.",
    "auth_cookie_accept": "Anlaşıldı",
    "sc_explainer_title": "Burada Gerçekten Ne Korunuyor?",
    "sc_explainer_desc": "GaiaShield, hesabınız, mesajlarınız ve ağ arasındaki koruyucu katmandır. İçeriğe değil, teknik risklere karar verir: manipülasyon, yeniden oynatma girişimleri, yetkisiz erişim, şüpheli giriş kalıpları ve güvensiz ağ geçidi geçişleri.",
    "sc_explainer_identity_desc": "Giriş anomalilerini, oturum risklerini ve diğer kimliklere erişimi kontrol eder.",
    "sc_explainer_messages_desc": "Yeniden oynatma modellerini, manipüle edilmiş paketleri ve bütünlük özelliklerinin eksikliğini tespit eder.",
    "sc_explainer_network_desc": "Güven yanlış görüntülenmeden önce federasyon, hız sınırı ve SMTP risklerini işaretler.",
    "sc_open_security_warnings": "Açık Güvenlik Uyarıları",
    "sc_opt_all": "Tümü",
    "sc_opt_low": "Düşük",
    "sc_opt_medium": "Orta",
    "sc_opt_high": "Yüksek",
    "sc_opt_critical": "Kritik",
    "sc_opt_failed_login": "Başarısız Giriş",
    "sc_opt_auth_attack": "Kimlik Doğrulama Saldırısı",
    "sc_opt_rate_limit": "Hız Sınırı",
    "sc_opt_policy_violation": "İlke Uyarısı",
    "sc_opt_message_replay": "Mesaj Yeniden Oynatma",
    "sc_node_security_data_unavailable": "Düğüm güvenlik verileri mevcut değil",
    "sc_total_events": "Toplam Olay",
    "sc_login_attacks": "Giriş Saldırıları",
    "sc_rate_limits_active": "Aktif Hız Sınırları",
    "sc_smtp_shield_hits": "SMTP Shield İsabetleri",
    "sc_top_event_categories": "En İyi Olay Kategorileri",
    "sc_no_entries": "Kayıt yok.",
    "sc_node_audit_log": "Düğüm Denetim Günlüğü (Son Olaylar)",
    "sc_no_node_events": "Düğüm olayı yok.",
    "archiv": "Arşiv",
    "entwuerfe": "Taslaklar",
    "markiert": "Yıldızlı",
    "wichtig": "Önemli",
    "snoozed": "Ertelenenler",
    "papierkorb": "Çöp Kutusu",
    "spam": "Spam",
    "cancel": "İptal",
    "error": "Hata",
    "success": "Başarılı",
    "kopieren": "Kopyala",
    "block_contact": "Kişiyi Engelle",
    "unblock_contact": "Kişinin Engelini Kaldır",
    "report_contact": "Kişiyi Bildir",
    "check_fingerprint": "Parmak İzini Doğrula",
    "export_encrypted": "Dışa Aktar (Şifreli)",
    "export_gaiaproof": "Dışa Aktar (GaiaProof)",
    "export_password_prompt": "Sohbet dışa aktarımını şifrelemek için lütfen bir şifre girin:",
    "export_success": "Sohbet başarıyla şifrelenerek dışa aktarıldı.",
    "export_failed": "Dışa aktarma başarısız oldu: ",
    "gaiaproof_export_success": "GaiaProof paketi başarıyla dışa aktarıldı.",
    "gaiaproof_export_failed": "GaiaProof dışa aktarımı başarısız oldu: ",
    "export_gaiaproof_confirm": "Tüm imzaları ve sunucu teslim makbuzlarını içeren GaiaProof paketini indirmek istiyor musunuz? Bu işlem biraz zaman alabilir.",
    "group_settings_is_private": "Özel Oda (herkese açık aranamaz, yalnızca katılım istekleriyle)",
    "group_settings_read_only": "Salt okunur mod (yalnızca sahip ve yöneticiler mesaj gönderebilir)",
    "group_settings_slow_mode": "Yavaş Mod (gönderme bekleme süresi)",
    "gsn_title": "GSN Sosyal Akışı",
    "gsn_node_feed": "Düğüm Akışı",
    "gsn_following_feed": "Takip Edilenler",
    "gsn_feed_empty": "Gönderi bulunamadı.",
    "gsn_composer_placeholder": "Federasyonda ne haber var?",
    "gsn_post_btn": "Paylaş",
    "gsn_profile": "Kullanıcı Profili",
    "gsn_followers": "Takipçiler",
    "gsn_following": "Takip Edilenler",
    "gsn_bio": "Açıklama / Biyografi:",
    "gsn_bio_label": "Açıklama / Biyografi",
    "gsn_display_name": "Görünen Ad",
    "gsn_edit_profile": "Profili Düzenle",
    "gsn_save_profile": "Kaydet",
    "gsn_add_image": "Resim Ekle (Şifreli)",
    "gsn_add_emoji": "Emoji Ekle",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Takip Et",
    "gsn_unfollow": "Takibi Bırak",
    "gsn_repost": "Paylaş / Yeniden Paylaş",
    "gsn_post_created": "Gönderi başarıyla paylaşıldı.",
    "gsn_image_uploaded": "Resim şifrelendi ve yüklendi.",
    "gsn_upload_failed": "Resim yükleme başarısız oldu: ",
    "gsn_comment_placeholder": "Bir yorum yaz...",
    "gsn_delete_confirm_title": "Gönderiyi sil?",
    "gsn_delete_confirm_desc": "Bu gönderiyi kalıcı olarak silmek istediğinizden emin misiniz?",
    "gsn_delete_comment_confirm_title": "Yorumu sil?",
    "gsn_delete_comment_confirm_desc": "Bu yorumu kalıcı olarak silmek istediğinizden emin misiniz?",
    "gsn_report": "Bildir",
    "gsn_report_title": "İhlali Bildir",
    "gsn_report_category": "Kategori",
    "gsn_report_spam": "Spam / Reklam",
    "gsn_report_harassment": "Taciz / Nefret Söylemi",
    "gsn_report_abuse": "Kötüye Kullanım",
    "gsn_report_illegal": "Yasa Dışı İçerik",
    "gsn_report_severity": "Önem Derecesi",
    "gsn_report_low": "Düşük",
    "gsn_report_medium": "Orta",
    "gsn_report_high": "Yüksek",
    "gsn_report_comment": "Ek Yorum",
    "gsn_report_submit": "Bildir",
    "gsn_report_submitted": "Rapor Yönetime iletildi.",
    "gsn_report_post": "Gönderiyi Bildir",
    "report_group": "Grubu Bildir",
    "report_group_reason_prompt": "Lütfen bildirim nedenini girin (isteğe bağlı):",
    "report_reason_prompt": "Lütfen bildirim nedenini girin (isteğe bağlı):",
    "report_failed": "Bildirim başarısız oldu: ",
    "report_success": "Kişi başarıyla bildirildi.",
    "room_read_only_placeholder": "Yalnızca sahip ve yöneticiler yazabilir",
    "read_only_active": "Salt okunur mod",
    "slow_mode_active": "Yavaş Mod aktif",
    "kommandozentrale": "Komuta Merkezi",
    "kontakt_blockiert": "Kişi engellendi",
    "kontakt_freigegeben": "Kişinin engeli kaldırıldı",
    "mailbox_settings_title": "Posta Kutusu Ayarları",
    "mailbox_settings_desc": "İmza, dil, e-posta filtrelerini yönetin.",
    "mic_access_denied": "Mikrofon erişimi reddedildi: ",
    "no_frequencies_active_desc": "İletişimi başlatmak için yeni bir oda oluşturun.",
    "key_changed_warning_title": "GÜVENLİK UYARISI:",
    "key_changed_warning_desc": "Bu gönderenin kimlik anahtarı güncellendi veya daha önce bilinen anahtardan farklı. Lütfen parmak izini başka bir güvenli kanaldan doğrulayın.",
    "sc_col_category": "Kategori",
    "search_members": "Üyeleri ara...",
    "tab_general": "Genel",
    "tab_members": "Üyeler",
    "tab_requests": "İstekler",
    "tab_invites": "Davetler",
    "tab_logs": "Günlükler",
    "auth_why_gaiacom": "Neden GaiaCOM?",
    "auth_why_gaiacom_desc": "Gizli iletişiminiz için güvenli, merkeziyetsiz alternatif.",
    "auth_self_managed_id": "Bireysel Yönetilen Kimlik",
    "auth_self_managed_id_desc": "E-posta veya telefon numarası vermeden anında güvenli kriptografik kimlikler oluşturun.",
    "auth_gaiadrop_secure_exchange": "Hesapsız Güvenli Alışveriş",
    "auth_gaiadrop_benefit_e2ee": "Uçtan Uca Şifreli",
    "auth_gaiadrop_benefit_no_login": "Giriş gerekmez",
    "auth_gaiadrop_benefit_inbox": "Alıcının gelen kutusuna doğrudan teslimat",
    "auth_terms_of_use": "Kullanım Koşulları",
    "auth_terms_of_use_show": "Kullanım Koşullarını Göster",
    "auth_consent_privacy_terms": "Gizlilik politikasını ve kullanım koşullarını okudum ve kabul ediyorum.",
    "auth_recovery_import_file": "Kurtarma Dosyasını İçe Aktar",
    "auth_recovery_password": "Kurtarma Dosyası Şifresi",
    "auth_recovery_local_password": "En az 12 karakterden oluşan yeni yerel kilit açma şifresi",
    "auth_recovery_decrypting": "Kurtarma Şifresi Çözülüyor...",
    "auth_recovery_back": "Girişe geri dön",
    "auth_cookie_sovereign": "GaiaCOM egemen kalmaya devam ediyor.",
    "auth_cookie_sovereign_desc": "Dil, oturum ve güvenlik için yalnızca teknik olarak gerekli yerel depolama özelliklerini kullanıyoruz. Takip yok, reklam çerezleri yok, üçüncü taraf profilleri yok.",
    "auth_cookie_sovereign_accept": "Anlaşıldı",
    "unlock_keyboard_toggle": "⌨️ Klavye Kullan",
    "unlock_keypad_toggle": "🔢 PIN Pedi Kullan",
    "unlock_status_denied": "ERİŞİM ENGELLENDİ / TEKRAR DENE",
    "unlock_status_decrypting": "KASA ŞİFRESİ ÇÖZÜLÜYOR...",
    "unlock_status_secured": "KASA GÜVENDE / KİLİTLİ",
    "auth_landing_nav_legal": "Yasal Bilgiler",
    "auth_landing_nav_beta": "Beta Testi",
    "auth_landing_card1_title": "Kuantum Sonrası Kriptografi (ML-KEM)",
    "auth_landing_card2_title": "%100 Merkeziyetsiz",
    "auth_landing_card3_title": "Sıfır Bilgi (Zero-Knowledge)",
    "auth_landing_card4_title": "Meta Veri Koruması",
    "auth_landing_card5_title": "Kendi Kendini Yöneten Kimlik",
    "auth_landing_hybrid_title": "Bugünün kriptografisi ve yarının tehditlerine karşı koruma.",
    "auth_landing_hybrid_desc": "GaiaCom, kendini kanıtlamış klasik anahtar değişimiyle kuantum sonrası kapsüllemeyi birleştirir. Derinlemesine savunma sağlar.",
    "auth_landing_x25519_desc": "Günümüz cihazları ve güvenli oturumlar için hızlı, kanıtlanmış eliptik eğri anahtar değişimi.",
    "auth_landing_mlkem_desc": "Gelecekteki şifre çözme senaryolarına karşı uzun vadeli gizlilik sağlayan kuantum sonrası anahtar kapsülleme.",
    "auth_landing_cycle_title": "Sunucu hiçbir şey görmez. Ağ sadece gürültü taşır.",
    "auth_landing_step1_title": "Yerel Şifreleme",
    "auth_landing_step1_desc": "Mesaj, ağa veya sunucuya ulaşmadan önce doğrudan gönderenin cihazında şifrelenir.",
    "auth_landing_step2_title": "Blob Olarak Taşıma",
    "auth_landing_step2_desc": "Paket, federe düğümler veya merkeziyetsiz depolama katmanları üzerinden kriptografik gürültü olarak iletilir.",
    "auth_landing_step3_title": "Federe Depolama",
    "auth_landing_step3_desc": "Ortada hedef teşkil edecek merkezi bir posta kutusu yoktur. Veriler parçalanmış, federe ve tamamen şifrelidir.",
    "auth_landing_step4_title": "Yerel Şifre Çözme",
    "auth_landing_step4_desc": "Yalnızca alıcının özel anahtarı şifreli paketi tekrar okunabilir içeriğe dönüştürebilir.",
    "auth_landing_trinity_title": "Tek bir protokol. Üç altyapı seviyesi.",
    "auth_landing_enterprise_desc": "Şirketler, hukuk büroları, KOBİ'ler, sanayi ve özel bankacılık için. Yönetimsel kontrollere ve desteğe sahip kapalı iletişim çevreleri.",
    "auth_landing_enterprise_list1": "İç egemenlik ve kullanıcı yönetimi",
    "auth_landing_enterprise_list2": "Kendi sunucunuzda barındırma veya yönetilen egemen küme",
    "auth_landing_enterprise_list3": "SLA, destek ve premium modüller",
    "auth_landing_network_desc": "Dijital gizlilik için açık ağ. Veri ticareti içermez, sadece özgür ve şifreli iletişim için bir altyapıdır.",
    "auth_landing_network_list1": "Açık kaynak kodlu istemci uygulaması",
    "auth_landing_network_list2": "Federe düğümler",
    "auth_landing_network_list3": "Merkezi şifre çözme anahtarı barındırmaz",
    "auth_landing_defend_desc": "Resmi makamlar, kritik altyapılar ve izole iletişim kanalları için yüksek güvenlikli özel altyapı.",
    "auth_landing_defend_list1": "İnternetten tamamen izole (air-gapped) kurulumlar",
    "auth_landing_defend_list2": "Özel markalama (white-label) ve kaynak kod denetimi",
    "auth_landing_defend_list3": "Ulusal dijital egemenlik",
    "auth_landing_gov_title": "Açık protokol. Ticari yürütme. Net yasal ayrım.",
    "auth_landing_gov_desc": "GaiaCom, açık protokolü, açık istemcileri ve ticari premium altyapıyı birbirinden ayırır. Güven şeffaflıktan doğar.",
    "auth_landing_price1_desc": "Mobil mağazalarda bot koruması sağlayan tek seferlik ücret.",
    "auth_landing_price2_desc": "Kodu kendisi derlemek isteyen kullanıcılar için ücretsiz.",
    "auth_landing_price3_desc": "Orta ölçekli işletmeler, hukuk büroları ve hassas ekipler için.",
    "auth_landing_price4_desc": "Şirketler, yüksek kullanılabilirlikli kümeler, LDAP ve yönetici kök erişimi için.",
    "auth_landing_license1_desc": "Kullanıcılar, çatallamalar ve topluluk denetimleri için maksimum kod şeffaflığı.",
    "auth_landing_license2_desc": "Protokolün ticari olarak kapatılmasını önleyen telif hakkı (copyleft) koruması.",
    "auth_landing_license3_desc": "LDAP, kök erişimi, denetim, SLA ve özel iş mantığı çözümleri.",
    "auth_landing_final_title": "Güven gerektirmeyen iletişim modeli.",
    "auth_landing_final_desc": "GaiaCom sadece e-postanın yerini almaz. Gizli iletişimin neden hala 40 yıllık eski varsayımlara ve okunabilir sunuculara dayandığını sorgulatır.",
    "auth_landing_final_note": "Not: Bu sayfa bir mimari vizyonu ve ürün yol haritasını açıklar. Güvenlik vaatleri üretim öncesinde denetimlerle doğrulanmalıdır."




  };

export default tr;